export default __webpack_public_path__ + "static/media/loading1.072b3f89.gif";